import { LoadingDialog } from '@/components/controls';
import { IntelligenceItemEditorDialog } from './IntelligenceItemEditorDialog';
import { useDeleteIntelligenceItem } from './useDeleteIntelligenceItem';
import { useIntelligenceItem } from './useIntelligenceItem';
import { useUpsertIntelligenceItem } from './useUpsertIntelligenceItem';

export function IntelligenceItemEditor({ code, isOpen, onClose, groupCodes }) {
  const {
    query: { data: item },
  } = useIntelligenceItem(code, {
    groupCodes: groupCodes ?? [],
    title: '',
    message: '',
    categories: [],
    intelligenceId: '',
    nominalIds: [],
    imageSrcs: [],
  });
  const { mutate: upsertItem } = useUpsertIntelligenceItem();
  const { mutate: deleteItem } = useDeleteIntelligenceItem();

  function handleClose(values) {
    if (values) {
      upsertItem(values);
    }

    onClose();
  }

  function handleDelete() {
    deleteItem(code);

    onClose();
  }

  return item ? (
    <IntelligenceItemEditorDialog
      item={item}
      isOpen={isOpen}
      onClose={handleClose}
      onDelete={handleDelete}
    />
  ) : (
    <LoadingDialog isOpen={isOpen} />
  );
}
